import * as TYPES from './type';
export default {
  //预习任务
  [TYPES.TASK_LIST](state, { result }) {
    state.taskList = result.result
  },
  [TYPES.TASK_INFO](state, { result, type }) {
    state.taskInfo[type] = result.result
  },
  [TYPES.TASK_LIST_STUDENT](state, { result }) {
    state.taskListStudent = result.result
  },
  [TYPES.COURSE_LIST](state, { result }) {
    state.courseList = result.result
  },
  [TYPES.PLAN_LIST](state, { result }) {
    state.planList = result.result
  },
  [TYPES.CLASS_LIST](state, { result }) {
    state.classList = result.result
  },
  [TYPES.TREE_LIST](state, { result }) {
    state.treeList = result.result
  },
  [TYPES.MESS_ADD](state, { result }) {
    state.messAdd = result.result
  },
  [TYPES.MESS_DEL](state, { result }) {
    state.messDel = result.result
  },
  [TYPES.MESS_READ](state, { result }) {
    state.messRead = result.result
  },
  [TYPES.MESS_LIST](state, { result }) {
    state.messList = result.result
  },
  [TYPES.TASK_TEST_STU](state, { result }) {
    state.taskTestStu = result.result
  },
  [TYPES.TASK_TEST_LIST](state, { result }) {
    state.taskTestList = result.result
  },
  [TYPES.EDIT_TASK_DATE](states, result) {
    states.editTaskDate = result;
  },
}



// WEBPACK FOOTER //
// ./src/store/yxTask/mutations.js